(() => {
  const state = window.koppaStockState;
  if (!state) return;
  const isPreorder = handle => state.preorders?.[handle] === true;
  const fromVariant = id => state.preorderVariants?.[String(id)];
  const handleFrom = node => node?.getAttribute('href')?.match(/\/products\/([^/?#]+)/)?.[1];
  const currentHandle = location.pathname.match(/\/products\/([^/?#]+)/)?.[1];
  const label = handle => handle === 'ghk-cu-trio' ? state.labels.protocolBuy : state.labels.creamBuy;
  const noteText = handle => handle === 'ghk-cu-trio' ? state.labels.protocolNote : state.labels.preorderNote;
  const setText = (node, value) => { if (node.textContent !== value) node.textContent = value; };
  const actionPattern = /^(?:pre-?order|shop|buy|get|add|view|explore|discover|reserve|choose|notify|join)\b/i;
  function actionText(node, handle) {
    if (!node || node.closest('[data-koppa-restock-option]') || node.querySelector('img,h1,h2,h3,[data-ploy-heading]')) return;
    const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
    let text;
    while ((text = walker.nextNode())) {
      if (text.parentElement.closest('svg') || !actionPattern.test(text.nodeValue.trim())) continue;
      const next = label(handle);
      if (text.nodeValue.trim() !== next) text.nodeValue = next;
    }
  }
  function restockOption(anchor, handle, placement = 'action') {
    if (!anchor || !isPreorder(handle) || !state.labels.notify || !document.getElementById('oos-pop')) return;
    let option = placement === 'card'
      ? anchor.querySelector(':scope > [data-koppa-restock-option]')
      : anchor.nextElementSibling?.matches('[data-koppa-restock-option]') ? anchor.nextElementSibling : null;
    if (!option) {
      option = document.createElement('div');
      option.dataset.koppaRestockOption = placement;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'koppa-preorder-restock';
      button.setAttribute('aria-haspopup', 'dialog');
      button.setAttribute('aria-controls', 'oos-pop');
      option.append(button);
      if (placement === 'card') anchor.append(option);
      else anchor.after(option);
    }
    const button = option.querySelector('button');
    button.dataset.koppaRestockHandle = handle;
    setText(button, state.labels.notify);
    const name = state.productNames?.[handle] || handle;
    const accessibleName = `${state.labels.notify}: ${name}`;
    if (button.getAttribute('aria-label') !== accessibleName) button.setAttribute('aria-label', accessibleName);
  }
  function makeNote(handle) {
    const note = document.createElement('div'); note.className = 'koppa-preorder-note'; note.dataset.preorderHandle = handle;
    const parts = [['strong', state.labels.preorder], ['p', noteText(handle)], ['strong', state.labels.priorityTitle], ['p', state.labels.priorityNote]];
    if (handle === 'ghk-cu-trio') parts.push(['p', state.labels.startNow]);
    parts.forEach(([tag,text]) => { const el = document.createElement(tag); el.textContent = text; if(text === state.labels.startNow) el.className = 'koppa-preorder-start'; note.append(el); });
    return note;
  }
  function prepareForm(form) {
    const handle = fromVariant(form.querySelector('[name="id"]')?.value);
    if (!isPreorder(handle)) return;
    const properties = {'Order type': state.labels.preorder, Dispatch: state.labels.dispatch, Fulfillment: state.labels.fulfillment};
    if (handle === 'ghk-cu-trio') properties['Dispatch together'] = state.labels.together;
    Object.entries(properties).forEach(([key, value]) => {
      const name = `properties[${key}]`;
      let input = form.querySelector(`input[name="${name}"]`);
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.append(input); }
      if (input.value !== value) input.value = value;
    });
    const existing = form.querySelector('.koppa-preorder-note');
    if (!existing) form.prepend(makeNote(handle));
    else if (existing.dataset.preorderHandle !== handle || !existing.querySelector('strong')) existing.replaceWith(makeNote(handle));
    form.querySelectorAll('[name="add"],button[type="submit"]').forEach(button => actionText(button, handle));
    restockOption(form, handle, 'form');
  }
  function statusNear(anchor) {
    if (!anchor || anchor.nextElementSibling?.classList.contains('koppa-preorder-status')) return;
    const status = document.createElement('p'); status.className = 'koppa-preorder-status'; status.textContent = state.labels.preorderStatus; anchor.after(status);
  }
  function scan() {
    document.querySelectorAll('a[href*="/products/"]').forEach(link => {
      const handle = handleFrom(link);
      if (!isPreorder(handle) || link.matches('.science__protocol-cta')) return;
      actionText(link, handle);
      if (!link.closest('.koppa-quick-add-card, .collection-product-card, .card-wrapper.product-card-wrapper, .ch-prod-card, .kh-category, [data-ploy-product-card], li.grid__item, article, koppa-card, form, footer, .cart-item, [data-koppa-restock-option]') &&
          !link.matches('.koppa-shopmenu__row, .kmn-product--nav, .koppa-drawer__row') &&
          !link.querySelector('img,h1,h2,h3,[data-ploy-heading]') && actionPattern.test(link.textContent.trim())) {
        restockOption(link, handle);
      }
      link.querySelectorAll('span,p').forEach(node => {
        if (!node.childElementCount && /^(In stock|Available now|Sold out|Preorder)$/i.test(node.textContent.trim())) setText(node, state.labels.preorder);
      });
      link.querySelectorAll('span.mt-auto, .koppa-drawer__cta').forEach(node => actionText(node,handle));
      if (link.matches('.koppa-shopmenu__row, .kmn-product--nav, .koppa-drawer__row') && !link.querySelector('[data-preorder-menu]')) {
        const status = document.createElement('small'); status.dataset.preorderMenu = ''; status.textContent = state.labels.preorder; (link.querySelector('.koppa-shopmenu__text') || link.querySelector('strong')?.parentElement || link).append(status);
      }
    });
    document.querySelectorAll('.koppa-quick-add-card').forEach(card => {
      const handle = card.dataset.koppaQuickAddReady || handleFrom(card.querySelector('a[href*="/products/"]'));
      if (!isPreorder(handle)) return;
      if (!card.hasAttribute('data-koppa-preorder-card')) card.dataset.koppaPreorderCard = handle;
      const button = card.querySelector('.koppa-quick-add-corner');
      if (button) {
        const mobileShopAll = window.matchMedia('(max-width: 767px)').matches && card.closest('[data-ploy-page="shop-all"]');
        setText(button, mobileShopAll ? '+' : label(handle));
        if(button.title!==label(handle))button.title=label(handle);
        if(button.getAttribute('aria-label')!==label(handle))button.setAttribute('aria-label',label(handle));
      }
      card.querySelectorAll('[data-koppa-restock-option]').forEach(option => {
        if (option.parentElement !== card || option.dataset.koppaRestockOption !== 'card') option.remove();
      });
      restockOption(card, handle, 'card');
      card.querySelectorAll('.koppa-shop-card-stock').forEach(el => setText(el,state.labels.preorder));
    });
    if (isPreorder(currentHandle)) {
      const gallery = document.querySelector('[data-ploy-product-gallery]');
      if (gallery && !document.querySelector('.koppa-preorder-status--mobile-top')) {
        const status = document.createElement('p'); status.className = 'koppa-preorder-status koppa-preorder-status--mobile-top'; status.textContent = state.labels.preorderStatus; gallery.before(status);
      }
      document.querySelectorAll('a[href="#product-purchase"], [data-mobile-sticky-action], .koppa-mobile-primary, [data-koppa-section-action]').forEach(node => {
        actionText(node,currentHandle);
        if (!node.closest('form')) restockOption(node, currentHandle, node.hasAttribute('data-mobile-sticky-action') ? 'sticky' : 'action');
      });
      document.querySelectorAll('.product-hero__title, .koppa-mobile-title').forEach(el => statusNear(el));
    }
    document.querySelectorAll('form[action*="/cart/add"]').forEach(prepareForm);
    document.querySelectorAll('.cart-item').forEach(item => {
      const link = item.querySelector('a[href*="/products/"]'), handle = handleFrom(link);
      if (!isPreorder(handle) || item.querySelector('[data-koppa-preorder-cart]')) return;
      const note = document.createElement('p'); note.dataset.koppaPreorderCart = ''; note.className = 'product-option'; note.textContent = `${noteText(handle)} ${state.labels.priorityNote}`;
      (item.querySelector('.cart-item__details') || link.parentElement).append(note);
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-koppa-restock-handle]');
    if (!button || typeof window.koppaOpenWaitlist !== 'function') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const handle = button.dataset.koppaRestockHandle;
    window.koppaOpenWaitlist({handle, name: state.productNames?.[handle] || handle});
  }, true);
  document.addEventListener('submit', event => { if (event.target.matches?.('form[action*="/cart/add"]')) prepareForm(event.target); }, true);
  let queued = false;
  const observer = new MutationObserver(() => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; scan(); }); });
  scan(); observer.observe(document.body, {subtree:true,childList:true});
  document.addEventListener('shopify:section:load', scan);
})();
